<template>
  <div
    class="appointment-title"
    :class="{
      'appointment-title_mobile': isMobile,
    }"
  >
    <h1
      class="text--text"
      :class="isMobile ? 'text-h6' : 'text-h5'"
      data-qa="appointment_doctor_title"
    >
      <template v-if="appointmentDataStore.appointmentPlaceTypes.isHome">
        {{ t('Вызвать врача на дом', options) }}
      </template>
      <template v-else-if="appointmentDataStore.appointmentPlaceTypes.isTelemed || appointmentDataStore.appointmentPlaceTypes.isTelemedMedtochka">
        {{ t('Запись на онлайн-консультацию', options) }}
      </template>
      <template v-else>
        {{ isMobile ? t('Проверьте данные и запишитесь', options) : t('Запись на приём к врачу', options) }}
      </template>
    </h1>

    <div
      v-if="isUserStaff && !isMobile"
      class="appointment-title__appointment-type text-body-1 text--text ml-5"
    >
      {{ appointmentDataStore.appointmentTypeLabel }}
    </div>
    <v-btn
      v-if="isMobile"
      icon
      text
      depressed
      class="ml-4"
      color="text"
      @click="handleClickClose"
    >
      <v-icon>
        ui-icon-close-not-a-circle
      </v-icon>
    </v-btn>
  </div>
</template>

<script lang="ts" setup>
import I18NextVue from 'i18next'
import { dispatchCustomEventGlobally } from 'www/utils'
import { EVENTS as DIALOG_EVENTS } from 'www/vue_components/common/core/BaseDialog/constants'
import { useAppointmentDataStore } from 'www/vue_components/common/AppointmentPage/stores'

const isMobile = window.MOBILE_VERSION
const isUserStaff = window.USER.isStaff
const { t, language } = I18NextVue
const options = { ns: language }

const appointmentDataStore = useAppointmentDataStore()

function handleClickClose() {
  dispatchCustomEventGlobally(DIALOG_EVENTS.open, {
    maxWidth: 304,
    title: `${t('Прервать запись', options)}?`,
    text: `${t('Ваше время может занять другой пациент', options)}.`,
    closeText: t('Вернуться', options),
    confirmText: t('Прервать', options),
    isDanger: true,
    beforeConfirm() {
      window.history.back()
    },
  })
}
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.appointment-title {
  display: flex;
  align-items: center;

  &_mobile {
    justify-content: space-between;
  }

  &__appointment-type {
    padding: 4px 8px;
    background-color: #FFFF00;
    border-radius: $border-radius-md;
  }
}
</style>
